import styled from 'styled-components';

const PriceBreakdownDropdown = styled.div`
  background-color: var(--color-bg-body);
  border-radius: var(--size-border-radius-md);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
  width: 380px;
`;

const DropdownHeader = styled.div`
  align-items: center;
  background-color: var(--color-bg-weaker);
  display: flex;
  justify-content: space-between;
  padding: 9px 16px;
`;

const DropdownHeaderTitle = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

const DropdownBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: var(--size-16);
  width: 100%;
`;

const DropdownBodyItem = styled.div`
  display: flex;
  justify-content: space-between;
`;

export {
  DropdownBody,
  DropdownBodyItem,
  DropdownHeader,
  DropdownHeaderTitle,
  PriceBreakdownDropdown
};
